function SideContent()
{
    return (
        <>
            <div className="col-side col-md-8">
                <h3>Welcome to Castlegate IT Support details</h3>
                <p>
                    This tool is designed to capture key browser information to help diagnose browser specific issues, please fill out your name and email address to send this information to our developer team.
                </p>
            </div>
        </>
    )
}

export default SideContent;